import MenuLink from "../MenuLink";  
import estilos from "./MenuNav.module.css";  

function MenuNav() {
    return (
        <nav className={estilos.navegacao}>  
           {/* Cada MenuLink cria um link para uma rota específica */}
           <MenuLink to="/">Sobre</MenuLink>  
           <MenuLink to="/personagens">Personagens</MenuLink> 
           <MenuLink to="/planetas">Planetas</MenuLink>  
        </nav> 
    );
}

export default MenuNav;
